<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请选择产品名称" v-model="queryParam.materialName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请选择编码" v-model="queryParam.code"></a-input>
                </a-form-item>
              </a-col>

              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-top: 5px">
        <!-- <a-button type="primary" @click="searchQuery">查询</a-button> -->
        <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
      </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
            @change="handleTableChange" style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="addLicense(record)">商品证照</a>
              <a-divider type="vertical" />
              <a type="primary" @click="toProductLicense(record)">查看详情</a>
              <a-divider type="vertical" />
              <a type="primary" @click="productApprocal(record)" :disabled="record.state == 1 || record.state == 2 || record.state == 3">审批</a>
              <!-- <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                <a type="primary">删除</a>
              </a-popconfirm> -->
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="orange">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <!-- <productModal ref="productModal" @ok="modalFormOk" @close="modalFormClose"></productModal> -->
        <a-modal ref="detail" :visible="showModal" @close="closeProductModal" :width="modal.width" @cancel="handleCancel" cancelText="关闭" >
          <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="1" tab="商品信息">
              <productInfo ref="productInfo" @ok="modalFormOk" @close="modalFormClose" :productInfo="productInfo"></productInfo>
            </a-tab-pane>
            <a-tab-pane key="2" tab="证照信息" force-render>
              <productLicense ref="productLicense" @ok="modalFormOk" @close="modalFormClose"></productLicense>

            </a-tab-pane>
          </a-tabs>

        </a-modal>
        <productLicenseList ref="modalLicenseList" @ok="modalFormOk" @close="modalFormClose" ></productLicenseList>
        <!-- <addProductLicense ref="modalLicense" @ok="modalFormOk" @close="modalFormClose" ></addProductLicense> -->
        <addProductModel ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></addProductModel>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//ledgerAdd
import addProductModel from '../modules/addProductModel'
import productLicenseList from '../modules/productLicenseList'
import addProductLicense from '../modules/addProductLicense'
import addModel from '../modules/addModel'
import productLisenceDetail from '../modules/productLisenceDetail'
import productModal from '../modules/productModal'
import { campListMixins } from '../mixins/campListMixins'
import { ledgerDelete,ledgerEdit, getProductDetail, materialApproval, productDelete} from '@/api/api'
import JDate from '@/components/jeecg/JDate'
import Product from '../product'
import productInfo from '../modules/productInfo'
import productLicense from '../modules/productLicense'


export default {
  name: 'RetailOutList',
  mixins: [campListMixins],
  components: {
    addProductModel,
    productLicenseList,
    productInfo,
    productLicense,
    JDate,
    addModel,
    addProductLicense,
    productModal,
    productLisenceDetail,
    Product
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      modal: {
        width: '1474px',
        dialogStyle: { top: '80px' },
        fullScreen: false
      },
      matype: {

      },
      productInfo: {},
      activeKey: "1",
      showModal: false,
      // 查询条件
      queryParam: {
        // page: 1,
        // limit: 20,
        // keywords: '',
        // specification: '',
        // codeSystem:''
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '产品名称', dataIndex: 'materialName', width: 140 ,ellipsis: true, render: (text) => text || "--" },
        { title: '编码', dataIndex: 'code', width: 160, render: (text) => text || "--" },
        { title: '规格/型号', dataIndex: 'model',width: 160, render: (text) => text || "--"},
        { title: '单位', dataIndex: 'unit', width: 140, render: (text) => text || "--" },
        { title: '有效日期', dataIndex: 'expirationDate',width: 120, render: (text) => text || "--"},
        { title: '状态', dataIndex: 'state',width: 100, scopedSlots: { customRender: 'state' }, render: (text) => text || "--"},

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          // fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/sy/material/list',

      },
    }
  },
  computed: {},
  created() {

  },
  methods: {
    addLicense(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalLicenseList.initShow(record)
    },
    closeProductModal(){
      this.showModal = false
    },
    handleCancel(){
      this.showModal = false
    },
    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    async handleAudit(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    //审批
    async productApprocal(record){
      console.log(record,'审核record============')
      let params = {
        materialId : record.materialId,
      }
      const res = await materialApproval(params)
      if(res.code == 200 && res.success == true){
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
      this.loadData()
    },
    //handleAuditCancel
    async handleAuditCancel(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    // 添加商品证照
    productLicense(record){

    },
    //查看商品证照列表
    async toProductLicense(record){
      console.log(record)
      this.showModal = true
      // this.productInfo = record
      let params = {
        id : record.materialId,
      }
      const res = await getProductDetail(params)
      if(res.code == 200 && res.success == true){
        this.productInfo = res.result
        this.$refs.productInfo.initShow(res.result)
        this.$refs.productLicense.initShow(res.result)
      }

    },
    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.materialId
      }
      const res = await productDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>